import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form } from 'react-final-form';
import { requestResetPassword } from '../actions/resetPassword';
import { FormEmail } from '../components/form/FormEmail';
import * as validators from '../components/Validate';
import logoImage from '../../assets/images/logo.png';

import '../sass/requestResetPassword.scss';
import { getIsSendingResetRequest, getRequestSentSuccess } from '../selectors/user/resetPassword';
import { useIntercom } from 'react-use-intercom';
import { isMobileWidth } from '../config';

const validator = values => {
    let { email } = values;
    let errors = {};

    if (email) {
        if (!validators.isCorrectEmail(email)) {
            errors.email = 'Wrong email format';
        }
    } else {
        errors.email = '';
    }

    return errors;
};

const RequestResetPassword = () => {
    const { boot, update } = useIntercom();
    const dispatch = useDispatch();

    const isSendingResetRequest = useSelector(getIsSendingResetRequest);
    const requestSentSuccess = useSelector(getRequestSentSuccess);

    const [values, setValues] = useState({
        email: ''
    });

    useEffect(() => {
        if (!isMobileWidth()) {
            document.title = 'Request Password Reset';
            boot({ customAttributes: { page: document.title } });
        }
    }, [boot]);

    const sendEmail = data => {
        setValues(data);
        if (!isMobileWidth()) {
            update({ customAttributes: { ...data } });
        }
        dispatch(requestResetPassword(data));
    };

    const buttonClass = isSendingResetRequest ? 'loader-button' : 'button';

    return (
        <div className="request-reset-password-page">
            <div className="content">
                <div className="left">
                    <Link to="/" className="logo">
                        <img className="logo-big" src={logoImage} alt="logo" />
                    </Link>
                    <div className="request-reset-password">
                        <h1>Reset Password</h1>
                        <Form initialValues={values} onSubmit={sendEmail} validate={validator}>
                            {({ handleSubmit }) => {
                                return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <FormEmail name="email" label="Your email" />
                                        <div className={buttonClass}>
                                            <button type="submit">
                                                <div className="loader" />
                                                Send Email
                                            </button>
                                        </div>
                                    </form>
                                );
                            }}
                        </Form>
                        <div className="message-success">
                            {requestSentSuccess && (
                                <label>
                                    If we found an account associated with {values.email}, we've sent password reset
                                    instructions to you. if an email is not received you may have used a different email
                                    for your FLK account.
                                </label>
                            )}
                        </div>
                    </div>
                </div>
                <div className="right" />
            </div>
        </div>
    );
};

export default memo(RequestResetPassword);
